import { Task } from "../types";
import { DailyTasksAdapter } from "../adapters/DailyTasksAdapter";
import {
  getTasksGroupDetails,
  postPartnerTasksGetReward,
} from "../../../Services/Requests";

export class DailyTasksService {
  static async getDailyTasks(groupId: number): Promise<Task[]> {
    console.log("🚀 DailyTasksService.getDailyTasks - start");

    try {
      return new Promise((resolve, reject) => {
        getTasksGroupDetails(groupId, (response: any) => {
          console.log(
            "✨ DailyTasksService.getDailyTasks - response",
            response
          );
          try {
            const adaptedTasks = DailyTasksAdapter.adaptTasks(
              response.tasks || response
            );
            resolve(adaptedTasks);
          } catch (error) {
            reject(error);
          }
        });
      });
    } catch (error) {
      console.error("❌ DailyTasksService.getDailyTasks - error", error);
      throw error;
    }
  }

  static async claimDailyTask(taskId: number): Promise<any> {
    try {
      const response = await postPartnerTasksGetReward(taskId);
      console.log("Claiming daily task:", taskId);
      console.log("Response:", response);

      return response;
    } catch (error) {
      console.error("❌ DailyTasksService.claimDailyTask - error", error);
      throw error;
    }
  }
}
